import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import constants from '../../../../common/constants';
import { toggleInfoModal } from '../actions/info-modal-actions';
import Button from '../../button/components/button';

import '../styles/info-modal.css';

class InfoModal extends Component {
  closeModal() {
    const { toggleInfoModal } = this.props;

    toggleInfoModal(false, '', '', null, null, null);
  }

  handleBtnClick(callback, path) {
    this.closeModal();

    if (callback) {
      callback();
      return;
    }

    if (path) {
      browserHistory.push(path);
    }
  }

  render() {
    const { show, type, message, translations, callback, path, btnText } = this.props;
    const { t } = this.context;
    const modalContent = constants.info_modal_types[type] || {};

    return (
      <Modal visible={show} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="info-modal-container">
          <div className={`info-modal-container__header header-${type}`}>
            <span className={`glyphicon ${modalContent.glyphicon}`} />
            <span className="info-modal-container__header__title m-l-10">{t(modalContent.title || '')}</span>
          </div>
          <div className="info-modal-container__body">
            <p className="info-modal-container__body__message">{t(message || '', translations || {})}</p>
            <Button label={btnText || 'COMMON.OK_THANKS'} customClass={`affiliate-btn-red info-modal-container__body__btn m-t-20 header-${type}`} onClick={() => this.handleBtnClick(callback, path)} />
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  show: state.infoModalReducer.show,
  type: state.infoModalReducer.type,
  message: state.infoModalReducer.message,
  translations: state.infoModalReducer.translations,
  callback: state.infoModalReducer.callback,
  path: state.infoModalReducer.path,
  btnText: state.infoModalReducer.btnText,
});

const mapDispatchToProps = dispatch => ({
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
});

InfoModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoModal);



// WEBPACK FOOTER //
// ./src/app/shared/info-modal/components/info-modal.js